import React from 'react';
import './DrawingControls.scss';

const DrawingControls = (props) => {
  const {
    hasDrawn,
    clearArtboard,
    isDrawing,
    setDrawing,
    currentStroke,
    setCurrentStroke,
    colourOptions,
    inView,
  } = props;
  return (
    <div className={`drawing-controls${inView ? ' is-visible' : ''}`}>
      <div className="container">
        <button
          type="button"
          className={`clear-button${hasDrawn ? ' is-visible' : ''}`}
          onClick={event => clearArtboard(event)}
        >
          <svg viewBox="0 0 37 35" xmlns="http://www.w3.org/2000/svg">
            <g fill="none" fillRule="evenodd">
              <path d="M.825 12.162l3.81-6.423c1.736-2.188 4.052-3.712 6.947-4.571 4.342-1.29 7.155-1.804 12.283 0 1.409.495 2.738.857 3.985 1.086l2.792 1.164c3.188 2.862 4.975 5.395 5.362 7.598.58 3.304.204 12.27-4.89 17.16-5.094 4.888-8.81 4.981-13.778 6.145-4.968 1.163-10.917-3.563-13.874-7.517-2.71-3.626-3.36-5.925-3.45-7.744A9.837 9.837 0 010 18.576c0-1.264.275-3.402.825-6.414z" fill="#FFFFF4" />
              <path
                className="spinner"
                d="M26.523 11.852a1.072 1.072 0 01-.036.102.851.851 0 01-.045.089.776.776 0 01-.132.166l-.063.054a.784.784 0 01-.01.008l-.01.006-.02.015a.78.78 0 01-.06.037l.08-.052a.786.786 0 01-.457.148h-3.903a.78.78 0 110-1.561h2.162a9.09 9.09 0 00-6.066-2.342c-4.735 0-8.587 3.852-8.587 8.587 0 4.736 3.852 8.588 8.587 8.588 4.736 0 8.588-3.852 8.588-8.588a.78.78 0 111.561 0c0 2.711-1.055 5.26-2.972 7.177a10.082 10.082 0 01-7.177 2.972c-2.71 0-5.26-1.055-7.176-2.972a10.082 10.082 0 01-2.973-7.177c0-2.71 1.056-5.26 2.973-7.176a10.083 10.083 0 017.176-2.972c2.596 0 5.14.99 7.028 2.669l-.001-1.889a.78.78 0 111.56 0v3.904c0 .029 0 .049-.002.069l.003-.07c0 .04-.003.078-.009.116l-.001.008-.018.084z"
                fill="#00BC74"
                fillRule="nonzero"
              />
            </g>
          </svg>
        </button>
        <button
          type="button"
          className={`drawing-toggle${isDrawing ? ' active' : ''}`}
          onClick={() => setDrawing(!isDrawing)}
        >
          <svg viewBox="0 0 35 34" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M30.61 13.331c-4.381 4.8-7.737 8.364-10.066 10.693-2.407 2.407-5.261 5.039-8.563 7.894h0l-5.216.641.005.006-5.227.643.643-5.228.005.006.641-5.217.434-.476c3.875-4.25 6.91-7.473 9.106-9.669 2.277-2.277 5.454-5.252 9.53-8.926h0l.324-.25c1.709-1.298 3.156-2.03 4.342-2.192 1.89-.26 6.927 4.708 7.28 6.258.236 1.034-.696 2.812-2.796 5.333h0zm-27.436 9.52l8.964 9.26"
              fill="#FFFFF4"
              stroke="#00BC74"
              strokeWidth="1.5"
              fillRule="evenodd"
              strokeLinejoin="round"
            />
          </svg>
        </button>
        { colourOptions && colourOptions.map(colour => (
          <button
            key={colour.hex}
            type="button"
            className={`colour-option${currentStroke.hex === colour.hex ? ' active' : ''}`}
            onClick={() => setCurrentStroke(colour)}
            style={{
              backgroundColor: colour.hex,
            }}
          />
        ))}
      </div>
    </div>
  );
};

export default DrawingControls;
